import React from 'react'
import styles from './page-header.module.scss'

const PageHeader = ({ className, title, text }) => {
  return (
    <div className={`${styles.styledPageHeader} ${className}`}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.text}>{text}</div>
    </div>
  )
}

export default PageHeader
